import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  const faqs = [{
    question: 'What is included in a full car detail?',
    answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
  }, {
    question: 'How long does a full detail take?',
    answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
  }, {
    question: 'How much does a full car detail cost?',
    answer: 'Our full detail starts at $300, with pricing adjusted for vehicle size and condition. SUVs and trucks are slightly higher. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'Is a full detail worth it before selling my car?',
    answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
  }, {
    question: 'Do you come to my home or office for a full detail?',
    answer: 'Yes. We are fully mobile and self-contained, bringing our own water and power to your home or office anywhere in Ventura County.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Full Car Detail',
    item: 'https://www.fulldetailpro.com/services/full-car-detail'
  }];
  return <ServicePageLayout title="Full Car Detail Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Complete full car detail in Ventura County \u2014 Camarillo, Oxnard & Thousand Oaks. Mobile interior deep clean + exterior wax & wax. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-608">
      <p data-id="element-609">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-610">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-611">What's Included in a Full Detail?</h2>
      <p data-id="element-612">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-613">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-614">
        <li className="flex items-start" data-id="element-615">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-616" />
          <span data-id="element-617">Wash method to safely remove surface dirt and grime.</span>
        </li>
        <li className="flex items-start" data-id="element-618">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-619" />
          <span data-id="element-620">
            <strong data-id="element-621">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-622">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-623" />
          <span data-id="element-624">
            <strong data-id="element-625">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-626">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-627" />
          <span data-id="element-628">
            <strong data-id="element-629">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-630">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-631">
        <li className="flex items-start" data-id="element-632">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-633" />
          <span className="font-[400]" data-id="element-634">
            Deep Vacuuming: Thorough removal of dirt and pet hair, followed
            steam clean carpets and cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-635">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-636" />
          <span data-id="element-637">
            <strong data-id="element-638">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-639">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-640" />
          <span data-id="element-641">
            <strong data-id="element-642">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-643">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-644" />
          <span data-id="element-645">
            <strong data-id="element-646">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-647">The Ultimate Value and Convenience</h2>
      <p data-id="element-648">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and power,
        allowing you to continue working or relaxing at home while we transform
        your car.
      </p>

      <h2 data-id="element-649">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-650">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>

      <h2 data-id="element-651">Related Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-652">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-653">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-654">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-655">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/ceramic-coating" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-656">
          Ceramic Coating &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}